import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeMount } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import AppDetailPage from "@/components/layout/AppDetailPage.vue"
import Profile from "@/modules/Clients/ClientDetail/Profile.vue"
import Subscriptions from "@/modules/Clients/ClientDetail/Subscriptions.vue"
import CompanyDetailsInfoForm, {
  CompanyProfile,
} from "@/modules/Clients/ClientDetail/CompanyDetailsInfoForm.vue"
import { useQuery } from "@vue/apollo-composable"
import useRouter from "@/router/useRouter"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import UserAvatar from "@/components/profile/UserAvatar.vue"
import { useUtilities } from "@/hooks/useUtilities"

import {
  Client,
  ClientsQuery,
  ClientsQueryQuery,
  DeleteClientMutation,
  DeleteClientMutationMutation,
  DeleteClientMutationMutationVariables,
  ClientDetailFragmentFragment,
} from "@/gql"
import { useCountry } from "@/hooks/useCountry"
import ClientAdmins from "@/modules/Clients/Settings/ClientAdmins.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientDetail',
  setup(__props) {

const selectedTab = ref<number | null>(null)
const showEditModal = ref(false)
const companyProfile = ref<CompanyProfile | null>(null)

const { router, routes } = useRouter()
const { mutate } = useMutation()
const { addSuccess } = useNotification()
const { updateSearchParams } = useUtilities()

const id = router.currentRoute.params.id
const client = ref<ClientDetailFragmentFragment | null>(null)
const showDeleteClientDialog = ref(false)
const deleting = ref(false)
const { getCountryFlag } = useCountry()

const {
  loading,
  onResult: onClientsQueryResult,
  refetch,
} = useQuery<ClientsQueryQuery>(ClientsQuery, {
  filter: {
    id,
  },
  per: 1,
})

onClientsQueryResult((result) => {
  if (result?.data?.clients?.data) {
    client.value = result?.data?.clients?.data[0] as Client

    const companyInfo = result?.data?.clients?.data[0]
    companyProfile.value = {
      name: companyInfo.name,
      clientId: companyInfo.prn,
      address: companyInfo.address,
      description: companyInfo.description as string,
      countryId: companyInfo.country.id,
      industry: null,
      website: companyInfo.website!,
    }
  }
})

const deleteClient = async () => {
  if (!client.value) return
  deleting.value = true

  // Mutate
  const result = await mutate<DeleteClientMutationMutation, DeleteClientMutationMutationVariables>({
    mutation: DeleteClientMutation,
    variables: {
      clientId: client.value.id,
    },
    handlePayloadErrors: true,
  })

  if (result?.data && !result.data.deleteClient.error) {
    router.push({
      name: routes.Clients,
    })
    addSuccess("Client deleted successfully")
  }
  deleting.value = false
}

const tabsMappings: Record<string, string> = {
  profile: "Profile",
  userManagement: "User management",
  subscription: "Subscriptions",
}

const onTabChange = (index: number) => {
  const tab = Object.keys(tabsMappings)[index]
  updateSearchParams({ key: "tab", value: tab })
}

const searchParams = new URLSearchParams(window.location.search)

onBeforeMount(() => {
  const currentTab = searchParams.get("tab")
  if (currentTab !== null) {
    const tabValue = Object.keys(tabsMappings).indexOf(currentTab)
    if (tabValue !== -1) {
      selectedTab.value = tabValue
    }
  }
})

return { __sfc: true,selectedTab, showEditModal, companyProfile, router, routes, mutate, addSuccess, updateSearchParams, id, client, showDeleteClientDialog, deleting, getCountryFlag, loading, onClientsQueryResult, refetch, deleteClient, tabsMappings, onTabChange, searchParams, Icon, AppDetailPage, Profile, Subscriptions, CompanyDetailsInfoForm, UserAvatar, ClientAdmins }
}

})